// Author YuJiaBei
// Date 2020-08-07 15:55:23

class EmLcInstalledReportInr {
constructor({
        id = null,
        inrCodeSde = '',
        inrCodeBda = '',
        inrCodeLoc = '',
        inrInstallStartTime = '',
        inrInstallEndTime = '',
        inrInstallSummary = '',
        inrInstallAttachment = '',
        inrInitiator = '',
        inrInitiatorLoginName = '',
        inrDescription = '',
        inrInstallAttachmentList = ''}
= {}) {
    this.id = id;
    this.inrCodeSde = inrCodeSde;
    this.inrCodeBda = inrCodeBda;
    this.inrCodeLoc = inrCodeLoc;
    this.inrInstallStartTime = inrInstallStartTime;
    this.inrInstallEndTime = inrInstallEndTime;
    this.inrInstallSummary = inrInstallSummary;
    this.inrInstallAttachment = inrInstallAttachment;
    this.inrInitiator = inrInitiator;
    this.inrInitiatorLoginName = inrInitiatorLoginName;
    this.inrDescription = inrDescription;
    this.inrInstallAttachmentList = inrInstallAttachmentList;
}
}

function newEntity() {
return new EmLcInstalledReportInr();
}

function gridFields() {
return Object.freeze([
        {
        key: 'status',
        label: 'label.em.lifecycle.emLcInstalledReportInr.grid.status',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'workOrderCode',
        label: 'label.em.lifecycle.emLcInstalledReportInr.grid.workOrderCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'inrCodeSde',
        label: 'label.em.lifecycle.emLcInstalledReportInr.grid.inrCodeSde',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'inrCodeBda',
        label: 'label.em.lifecycle.emLcInstalledReportInr.grid.inrCodeBda',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'emArchBdaName',
        label: 'label.em.lifecycle.emLcInstalledReportInr.grid.emArchBdaName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'inrCodeLoc',
        label: 'label.em.lifecycle.emLcInstalledReportInr.grid.inrCodeLoc',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'emArchLocName',
        label: 'label.em.lifecycle.emLcInstalledReportInr.grid.emArchLocName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'inrInstallStartTime',
        label: 'label.em.lifecycle.emLcInstalledReportInr.grid.inrInstallStartTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'inrInstallEndTime',
        label: 'label.em.lifecycle.emLcInstalledReportInr.grid.inrInstallEndTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'inrInstallSummary',
        label: 'label.em.lifecycle.emLcInstalledReportInr.grid.inrInstallSummary',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'inrInstallAttachmentList',
        label: 'label.em.lifecycle.emLcInstalledReportInr.grid.inrInstallAttachmentList',
        sortable: true,
            isDetail: true,
        form: {
        type: 'emAttachment'
        }
        },
        {
        key: 'inrInitiatorLoginName',
        label: 'label.em.lifecycle.emLcInstalledReportInr.grid.inrInitiatorLoginName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'inrApplyTime',
        label: 'label.em.lifecycle.emLcInstalledReportInr.grid.inrApplyTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'inrDescription',
        label: 'label.em.lifecycle.emLcInstalledReportInr.grid.inrDescription',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        },
        {
        key: 'statusName',
        label: 'label.em.lifecycle.emLcInstalledReportInr.grid.statusName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'emAclDeptName',
        label: 'label.em.lifecycle.emLcInstalledReportInr.grid.emAclDeptName',
        sortable: true,
        form: {
        type: 'input'
        }
        }
]);
}

const filter = {
    statusFilter : "",
    workOrderCodeFilter : "",
    inrCodeSdeFilter : "",
    inrCodeBdaFilter : "",
    inrCodeLocFilter : "",
    inrInstallEndTimeRteFilter : "",
    inrInstallEndTimeLteFilter : "",
    inrInstallSummaryFilter : "",
    inrInitiatorFilter : "",
    inrInitiatorLoginNameFilter : "",
    workflowQueryTypeFilter : "",
    emAclDeptIdFilter : "",
    emAclDeptNameFilter : "",
    emAclDeptNodeCodeFilter : "",
    emAclDeptNodeCodeNameFilter : "",
    emArchLocCodeFilter : "",
    emArchLocNodeCodeFilter : "",
    emArchLocNodeCodeNameFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'statusFilter',
        label: 'label.em.lifecycle.emLcInstalledReportInr.filter.status',
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'emActProcessStatus'
            ,showLabelSelectOne: true
                    ,selectFilter:{processBusinessEntityFilter:'EmLcInstalledReportInr',statusFilter:1}
        }
        },
        {
        key: 'workOrderCodeFilter',
        label: 'label.em.lifecycle.emLcInstalledReportInr.filter.workOrderCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'inrCodeSdeFilter',
        label: 'label.em.lifecycle.emLcInstalledReportInr.filter.inrCodeSde',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'inrCodeBdaFilter',
        label: 'label.em.lifecycle.emLcInstalledReportInr.filter.inrCodeBda',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emArchBasicData'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'inrInstallEndTimeRteFilter',
        label: 'label.em.lifecycle.emLcInstalledReportInr.filter.inrInstallEndTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'inrInstallEndTimeLteFilter',
        label: 'label.em.lifecycle.emLcInstalledReportInr.filter.inrInstallEndTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'inrInstallSummaryFilter',
        label: 'label.em.lifecycle.emLcInstalledReportInr.filter.inrInstallSummary',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'inrInitiatorLoginNameFilter',
        label: 'label.em.lifecycle.emLcInstalledReportInr.filter.inrInitiatorLoginName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
            ,fieldsBindingByEntityModalSelected: '{"inrInitiator":"id"}'
                }
        },
        {
        key: 'emAclDeptNameFilter',
        label: 'label.em.lifecycle.emLcInstalledReportInr.filter.emAclDeptName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclDept'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"emAclDeptId":"id"}'
                }
        },
        {
        key: 'emAclDeptNodeCodeNameFilter',
        label: 'label.em.lifecycle.emLcInstalledReportInr.filter.emAclDeptNodeCodeName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclDept'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"emAclDeptNodeCode":"nodeCode"}'
                }
        },
        {
        key: 'emArchLocCodeFilter',
        label: 'label.em.lifecycle.emLcInstalledReportInr.filter.emArchLocCode',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emLocation'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'emArchLocNodeCodeNameFilter',
        label: 'label.em.lifecycle.emLcInstalledReportInr.filter.emArchLocNodeCodeName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emLocation'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"emArchLocNodeCode":"nodeCode"}'
                }
        }
];

const entityFormConfigs = [
        {
        key: 'inrCodeSde',
        label: 'label.em.lifecycle.emLcInstalledReportInr.entity.inrCodeSde',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'inrCodeBda',
        label: 'label.em.lifecycle.emLcInstalledReportInr.entity.inrCodeBda',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emLocation'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'inrCodeLoc',
        label: 'label.em.lifecycle.emLcInstalledReportInr.entity.inrCodeLoc',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emLocation'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'inrInstallStartTime',
        label: 'label.em.lifecycle.emLcInstalledReportInr.entity.inrInstallStartTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'inrInstallEndTime',
        label: 'label.em.lifecycle.emLcInstalledReportInr.entity.inrInstallEndTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'inrInstallSummary',
        label: 'label.em.lifecycle.emLcInstalledReportInr.entity.inrInstallSummary',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'inrInitiatorLoginName',
        label: 'label.em.lifecycle.emLcInstalledReportInr.entity.inrInitiatorLoginName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
            ,fieldsBindingByEntityModalSelected: '{"inrInitiator":"id"}'
                }
        },
        {
        key: 'inrDescription',
        label: 'label.em.lifecycle.emLcInstalledReportInr.entity.inrDescription',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        },
        {
        key: 'inrInstallAttachmentList',
        label: 'label.em.lifecycle.emLcInstalledReportInr.entity.inrInstallAttachment',
        sortable: false,
        disabled: false,
        form: {
        type: 'emAttachment'
            ,correspondingField: 'inrInstallAttachment'
                }
        }
]

export {EmLcInstalledReportInr, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs , filterConfigs}
